var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.openSubtitle),expression:"!openSubtitle"}],staticClass:"material-area",style:({'z-index': _vm.getPaneStatus === 'pane-enter' ? 20 : 1})},[_c('resourceCategories'),_vm._v(" "),_c('visualSceneArea')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14606d20","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MaterialArea.vue
// module id = null
// module chunks = 